import React from "react";
import { QRProps } from "@/contexts/QREditorContext/types";
import { PreviewUrlUnified } from "./PreviewUrlUnified";

/**
 * Wrapper de compatibilidad para PreviewUrlStatic
 * Mantiene la API existente mientras usa la lógica unificada
 */
export default function PreviewUrlStatic(props: QRProps<"url-static">) {
  return (
    <PreviewUrlUnified
      qrProps={props}
      page="url-static"
      dataQA="preview-url-static-container"
      translationKey="url_static"
    />
  );
}
